// extracted by mini-css-extract-plugin
module.exports = {"loader":"Dashboard_loader__y-TeO","wrapper":"Dashboard_wrapper__1vRWN","carousel":"Dashboard_carousel__1Jx6A"};